<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Custom Views'|translate }}
                </v-card-title>
                <v-card-actions v-if="!loading">
                    <v-spacer></v-spacer>
                    <span style="width:120px" class="mr-2" v-if="$can('update', 'Config')"><v-switch color="success"
                                                                                                     v-model="viewAll"
                                                                                                     :label="'View All'|translate"
                    ></v-switch></span>
                    <span style="width:300px;"><v-text-field class="mr-4" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-btn class="accent" @click="$router.push({path: '/multiplots'})">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'New Simple View'|translate }}
                    </v-btn>
                    <v-btn class="accent" @click="$router.push({path: '/custom-view-builder'})">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'New Advanced View'|translate }}
                    </v-btn>
                    <v-btn
                        class="accent"
                        @click="mcdialog=true">
                        <v-icon small class="mr-2">fa-bars</v-icon>
                        {{'Menu config'|translate}}
                    </v-btn>
                    <v-btn class="accent" @click="dialog=true">
                        <v-icon small class="mr-2">fa-upload</v-icon>
                        {{ 'Import JSON'|translate }}
                    </v-btn>
                    <v-btn class="accent" v-if="hasExternalRepository" @click="openRepositoryDialog()">
                        <v-icon small class="mr-2">fa-cloud-download-alt</v-icon>
                        {{ 'Import from repository'|translate }}
                    </v-btn>
                    <v-btn class="accent" @click="uploadLocal">
                        <v-icon small class="mr-2">fa-upload</v-icon>
                        {{ 'Import Local Plots'|translate }}
                    </v-btn>
                    <v-dialog v-model="dialog" max-width="800" persistent>
                        <v-card>
                            <v-card-title class="primary white--text title">
                                {{ 'Import custom view from JSON'|translate }}
                            </v-card-title>
                            <editor v-model="jsonImport" @init="editorInit" lang="json" theme="twilight" width="100%"
                                    height="500"></editor>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="primary" :disabled="!jsonImport||jsonImport===''" @click="importFromJson">
                                    {{ 'Import'|translate }}
                                </v-btn>
                                <v-btn @click="jsonImport=''; dialog=false">{{ 'Cancel'|translate }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="assignDialog" max-width="500" persistent>
                        <v-card>
                            <v-card-title class="primary white--text title">
                                {{ 'Change custom view owner'|translate }}
                            </v-card-title>
                            <v-card-text>
                                <v-autocomplete v-model="assignTo" :items="users" item-text="user_name" item-value="user_id" :label="'New owner'|translate"></v-autocomplete>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="primary" :disabled="!assignTo" @click="runAssign">
                                    {{ 'Assign new owner'|translate }}
                                </v-btn>
                                <v-btn @click="assignDialog=false">{{ 'Cancel'|translate }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="repositoryImportDialog" max-width="1000" persistent>
                        <v-card>
                            <v-card-title class="primary white--text title">
                                {{ 'Import views from centralized repository'|translate }}
                            </v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <span style="width:300px;"><v-text-field class="mr-4" clearable v-model="searchRep" type="text"
                                                                         :label="'Keyword filter'|translate"></v-text-field></span>
                            </v-card-actions>
                            <v-card-text>
                                <v-data-table
                                    :headers="repositoryHeaders"
                                    :items="repositoryViews"
                                    :loading="repositoryViewsLoading"
                                    class="elevation-1"
                                    :search="searchRep2"
                                    :rows-per-page-items="[25,50,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                >
                                    <template v-slot:items="props">
                                        <td>{{ props.item.title }}</td>
                                        <td>{{ props.item.facility }}</td>
                                        <td>{{ props.item.lastUpdated }}</td>
                                        <td>
                                            <v-tooltip bottom class="mr-2">
                                                <template v-slot:activator="{ on }">
                                                    <v-icon class="mr-2"
                                                            small
                                                            v-on="on"
                                                            @click="importFromRepository(props.item)"
                                                    >
                                                        fa-cloud-download-alt
                                                    </v-icon>
                                                    <v-icon
                                                        small
                                                        @click="deleteRepositoryView(props.item)"
                                                    >
                                                        fa-trash
                                                    </v-icon>
                                                </template>
                                                <span>{{ 'Import'|translate }}</span>
                                            </v-tooltip>
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click="repositoryImportDialog=false">{{ 'Close'|translate }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="mcdialog" max-width="1200" persistent>
                        <menu-config v-if="mcdialog" closable @close="mcdialog=false"></menu-config>
                    </v-dialog>
                </v-card-actions>
                <v-card-text v-if="loading">
                    <v-progress-linear :indeterminate="true"></v-progress-linear>
                </v-card-text>
                <v-card-text v-if="!loading">
                    <v-data-table
                        :headers="conditionedHeaders"
                        :items="customViews"
                        :search="search2"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.title }}</td>
                            <td>{{ props.item.id }}</td>
                            <td>{{ props.item.facility }}</td>
                            <td>{{ props.item.published ? 'Yes' : 'No' | translate }}</td>
                            <td>{{ props.item.lastUpdated }}</td>
                            <td v-if="viewAll">{{ getUserName(props.item.user_id) }}</td>
                            <td>
                                <v-tooltip bottom class="mr-2" v-if="!props.item.published">
                                    <template v-slot:activator="{ on }">
                                        <v-icon class="mr-2"
                                                small
                                                v-on="on"
                                                @click="publishUserPlot(props.item)"
                                        >
                                            fa-arrow-up
                                        </v-icon>
                                    </template>
                                    <span>{{ 'Publish'|translate }}</span>
                                </v-tooltip>
                                <v-tooltip bottom class="mr-2" v-if="props.item.published">
                                    <template v-slot:activator="{ on }">
                                        <v-icon class="mr-2"
                                                small
                                                v-on="on"
                                                @click="unpublishUserPlot(props.item)"
                                        >
                                            fa-arrow-down
                                        </v-icon>
                                    </template>
                                    <span>{{ 'Un-Publish'|translate }}</span>
                                </v-tooltip>
                                <v-tooltip bottom class="mr-2">
                                    <template v-slot:activator="{ on }">
                                        <v-icon class="mr-2"
                                                small
                                                v-on="on"
                                                @click="exportItem(props.item)"
                                        >
                                            fa-download
                                        </v-icon>
                                    </template>
                                    <span>{{ 'Export'|translate }}</span>
                                </v-tooltip>
                                <v-tooltip bottom class="mr-2" v-if="viewAll">
                                    <template v-slot:activator="{ on }">
                                        <v-icon class="mr-2"
                                                small
                                                v-on="on"
                                                @click="openAssign(props.item)"
                                        >
                                            fa-user
                                        </v-icon>
                                    </template>
                                    <span>{{ 'Change Owner'|translate }}</span>
                                </v-tooltip>
                                <v-tooltip bottom class="mr-2" v-if="hasExternalRepository">
                                    <template v-slot:activator="{ on }">
                                        <v-icon class="mr-2"
                                                small
                                                v-on="on"
                                                @click="exportViewToRepository(props.item)"
                                        >
                                            fa-cloud-upload-alt
                                        </v-icon>
                                    </template>
                                    <span>{{ 'Export to centralized repository'|translate }}</span>
                                </v-tooltip>

                                <v-icon class="mr-2"
                                        small
                                        @click="viewView(props.item)"
                                >
                                    fa-eye
                                </v-icon>
                                <v-icon class="mr-2"
                                        small
                                        v-if="props.item.plotList&&props.item.plotList[0]&&props.item.plotList[0].type!=='multi-chart'"
                                        @click="editView(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon class="mr-2"
                                        small
                                        v-if="props.item.plotList&&props.item.plotList[0]&&props.item.plotList[0].type!=='multi-chart'"
                                        @click="duplicateView(props.item)"
                                >
                                    fa-copy
                                </v-icon>
                                <v-icon
                                    small
                                    @click="deleteView(props.item)"
                                >
                                    fa-trash
                                </v-icon>

                            </td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {uniqueid, putCustomView, getCustomViews, deleteCustomView, getUser} from "../helper";
import editor from 'vue2-ace-editor'
import moment from "moment";
import MenuConfig from "./MenuConfig";

export default {
    name: 'CustomViews',
    components: {editor,MenuConfig},
    computed: {
        ...mapGetters([
            'userPlots','activateExternalViewRepository',
        ]),
        customViews() {
            return this.viewAll ? this.userPlots : this.userPlots.filter(x => x.user_id === this.$store.state.userStore.user.content.sub)
        },
        conditionedHeaders() {
            return this.viewAll ? this.adminHeaders : this.headers
        },
        hasExternalRepository() {
            if (process.env.VUE_APP_SUPERUSER&&process.env.VUE_APP_SUPERUSER!==""){
                if (!this.$store.state.userStore.user.content.user_name.toLowerCase().includes(process.env.VUE_APP_SUPERUSER)||!this.$can('update', 'Config')){
                    return false
                }
            } else {
                if (!(this.$store.state.userStore.user.content.user_name.toLowerCase().includes("carnot")||this.$store.state.userStore.user.content.user_name==="jecdavid") || !this.$can('update', 'Config')) {
                    return false
                }
            }
            return this.activateExternalViewRepository || (process.env.VUE_APP_EXTERNAL_VIEW_REPOSITORY && process.env.VUE_APP_EXTERNAL_VIEW_REPOSITORY !== "")
        }
    },
    data() {
        return {
            loading: false,
            users:[],
            dialog: false,
            assignDialog: false,
            assignItem: null,
            assignTo: null,
            mcdialog: false,
            repositoryViews: [],
            repositoryImportDialog: false,
            repositoryViewsLoading: false,
            jsonImport: "",
            search: '',
            search2: '',
            searchRep2: '',
            searchRep: '',
            timeout: null,
            viewAll: false,
            headers: [
                {text: this.$options.filters.translate('Title'), value: 'title'},
                {text: this.$options.filters.translate('ID'), value: 'id'},
                {text: this.$options.filters.translate('Facility'), value: 'facility'},
                {text: this.$options.filters.translate('Published'), value: 'published'},
                {text: this.$options.filters.translate('Last Updated'), value: 'lastUpdated'},
                {text: this.$options.filters.translate('Actions'), value: 'title', sortable: false},
            ],
            adminHeaders: [
                {text: this.$options.filters.translate('Title'), value: 'title'},
                {text: this.$options.filters.translate('ID'), value: 'id'},
                {text: this.$options.filters.translate('Facility'), value: 'facility'},
                {text: this.$options.filters.translate('Published'), value: 'published'},
                {text: this.$options.filters.translate('Last Updated'), value: 'lastUpdated'},
                {text: this.$options.filters.translate('Owner'), value: 'user_id'},
                {text: this.$options.filters.translate('Actions'), value: 'title', sortable: false},
            ],
            repositoryHeaders: [
                {text: this.$options.filters.translate('Title'), value: 'title'},
                {text: this.$options.filters.translate('Facility'), value: 'facility'},
                {text: this.$options.filters.translate('Last Updated'), value: 'lastUpdated'},
                {text: this.$options.filters.translate('Actions'), value: 'title', sortable: false},
            ],
        }
    },

    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        },
        searchRep() {
            this.debounce(this.syncRepSearches, 500);
        }
    },
    mounted() {
        let me = this
        getUser({}).then(function (df) {
            me.users = df.users
        })
    },
    methods: {
        ...mapActions([
            'publishUserPlot', 'unpublishUserPlot',
        ]),
        getUserName(id){
            for (let user of this.users){
                if(user.user_id===id){
                    return user.user_name
                }
            }
            return id
        },
        openAssign(item){
            this.assignItem=JSON.parse(JSON.stringify(item))
            this.assignTo=null
            this.assignDialog=true
        },
        async runAssign(){
            this.assignItem.user_id=this.assignTo
            await this.$store.dispatch('addUserPlot', this.assignItem)
            this.assignDialog=false
        },
        importFromRepository: function (view) {
            let newPlot = JSON.parse(JSON.stringify(view))
            let me = this
            newPlot.facility = me.$store.state.pointsListStore.pointsList.facility_name
            newPlot.user_id = me.$store.state.userStore.user.content.sub
            if (newPlot.id && me.userPlots.filter(x => x.id === newPlot.id).length > 0) {
                if (confirm(this.$options.filters.translate('A custom view with this ID already exists. Are you sure you want to override it ?'))) {
                    me.$store.dispatch('addUserPlot', newPlot).then(function () {
                        me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('Custom view saved')})
                    })
                }
            } else {
                this.$store.dispatch('addUserPlot', newPlot).then(function () {
                    me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('Custom view saved')})
                })
            }
        },
        async openRepositoryDialog() {
            this.repositoryViewsLoading = true
            this.repositoryImportDialog = true
            await this.getRepositoryViews()
            this.repositoryViewsLoading = false
        },
        async getRepositoryViews() {
            let result = await getCustomViews(
                {
                    apiBaseUrl: process.env.VUE_APP_EXTERNAL_VIEW_REPOSITORY
                }
            )
            this.repositoryViews = result.views.map(x => {
                let a = x.json
                a.published = false
                a.user_id = x.user_id
                return a
            })
        },
        async exportViewToRepository(view) {
            if (confirm('Export this view to centralized repository?')) {
                let newView = JSON.parse(JSON.stringify(view))
                newView.id = uniqueid()
                newView.published = false
                newView.lastUpdated = moment().format('YYYY-MM-DD HH:mm:ss')
                await putCustomView(
                    {
                        apiBaseUrl: process.env.VUE_APP_EXTERNAL_VIEW_REPOSITORY,
                        view_id: newView.id,
                        published: false,
                        json: newView
                    },
                )
                await this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('View Exported')})
            }
        },
        syncSearches() {
            this.search2 = this.search
        },
        syncRepSearches() {
            this.searchRep2 = this.searchRep
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        deleteView(view) {
            let me = this
            if (confirm('Are you sure you want to delete this view?')) {
                me.$store.dispatch('deleteUserPlot', view).then(function () {
                    me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('View Deleted')})
                })
            }
        },
        deleteRepositoryView(view) {
            let me = this
            if (confirm('Are you sure you want to delete this view from the centralized repository?')) {
                deleteCustomView({
                    apiBaseUrl: process.env.VUE_APP_EXTERNAL_VIEW_REPOSITORY,
                    view_id:view.id
                }).then(function () {
                    me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('View Deleted')})
                    me.getRepositoryViews()
                })
            }
        },

        duplicateView(view) {
            let me = this
            let newView = JSON.parse(JSON.stringify(view))
            newView.id = uniqueid()
            newView.title = newView.title + " copy"
            newView.linkTitle = newView.linkTitle + " copy"
            newView.user_id = me.$store.state.userStore.user.content.sub
            newView.published = false
            me.$store.dispatch('addUserPlot', newView).then(function () {
                me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('Custom view saved')})
                let output = {
                    path: '/custom-view-builder',
                    query: {
                        view: newView.id,
                    }
                }
                me.$router.push(output)
            })
        },
        editView(view) {
            let output = {
                path: '/custom-view-builder',
                query: {
                    view: view.id,
                }
            }
            this.$router.push(output)
        }, viewView(view) {
            let output = {
                path: '/user-automated/' + view.id,
            }
            this.$router.push(output)
        },
        async uploadLocal() {
            let plots = JSON.parse(localStorage.getItem('userPlots'))
            if (plots && plots.length > 0) {
                let me = this
                if (confirm(this.$options.filters.translate('Are you sure you want to upload all local plots to your user account?'))) {
                    me.loading = true
                    for (let plot of plots) {
                        await me.$store.dispatch('addUserPlot', plot)
                    }
                    await this.$store.dispatch('refreshUserPlots')
                    me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('Views Imported')})
                    me.loading = false
                }
            }
        },
        exportItem(item) {
            let file = new Blob([JSON.stringify(item, undefined, 3)], {type: 'application/json'});
            let a = document.createElement('a');
            a.href = URL.createObjectURL(file);
            a.download = item.facility + "-" + item.title + ".json";
            a.click();
        },
        editorInit: function () {
            require('brace/ext/language_tools')
            require('brace/mode/json')
            require('brace/theme/twilight')
        },
        importFromJson: function () {
            let newPlot = JSON.parse(this.jsonImport)
            let me = this
            newPlot.facility = me.$store.state.pointsListStore.pointsList.facility_name
            if (newPlot.id && me.userPlots.filter(x => x.id === newPlot.id).length > 0) {
                if (confirm(this.$options.filters.translate('A custom view with this ID already exists. Are you sure you want to override it ?'))) {
                    me.$store.dispatch('addUserPlot', newPlot).then(function () {
                        me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('Custom view saved')})
                    })
                    me.jsonImport = ""
                    me.dialog = false
                }
            } else {
                this.$store.dispatch('addUserPlot', newPlot).then(function () {
                    me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('Custom view saved')})
                })
                this.jsonImport = ""
                this.dialog = false
            }

        },
        copyChart(plot) {
            let newPlot = JSON.parse(JSON.stringify(plot))
            newPlot.editDialog = false
            newPlot.id = uniqueid()
            return newPlot
        },
    }
}
</script>

<style scoped>

</style>
